import clsx from 'clsx';

type Tone = 'ok' | 'warn' | 'fail' | 'idle';

const tones: Record<Tone, string> = {
  ok: 'bg-success',
  warn: 'bg-warning',
  fail: 'bg-error',
  idle: 'bg-content-muted',
};

export function StatusDot({ tone = 'idle', className }: { tone?: Tone; className?: string }) {
  return <span className={clsx('inline-block h-1.5 w-1.5 rounded-full', tones[tone], className)} />;
}
